const languages = [
    {
        id: 1,
        language : 'HTML' ,
        image : 'assets/IMG_20220218_163129.png' ,
        description : ' A language used to define a structure of a web page ' 

    },
     {
        id: 2,
        language : 'CSS' ,
        image : 'assets/IMG_20220218_163154.png' ,
        description : ' A language for styling web pages ' 

    },
     {
        id: 3,
        language : 'JavaScript' ,
        image : 'assets/IMG_20220218_163143.png' ,
        description : ' A Programming language for manuplating web pages' 

    },
     {
        id: 4,
        language : 'Boostrap' ,
        image : 'assets/IMG_20220218_163525.png' ,
        description : ' A css framework for building faster and responsive website' 

    },
     {
        id: 5,
        language : '' ,
        image : 'assets/IMG_20220218_163642.png' ,
        description : ' A css preprocessor that extends css functionalities' 

    },
     {
        language : '' ,
        id: 6,
        image : 'assets/IMG_20220218_163404.png' ,
        description : ' A javascript transpiler that translate javascript code to Es5' 

    },
     {
        id: 7,
        language : 'React' ,
        image : 'assets/IMG_20220218_163233.png' ,
        description : ' A Javacript Library for building user interface' 

    },
     {
        id: 8,
        language : 'Git' ,
        image : 'assets/IMG_20220218_163338.png' ,
        description : 'Version Control System' 

    },
     {
        id: 9,
        language : 'Redux' ,
        image : 'assets/IMG_20220218_163259.png' ,
        description : 'A JavaScript state management library' 

    },
     {
        id: 10,
        language : '' ,
        image : 'assets/IMG_20220218_163754.jpg' ,
        description : 'The most popular server side programming language' 

    },
     {
        id: 11,
        language : '' ,
        image : 'assets/IMG_20220219_141057.png' ,
        description : 'A relational database management system.' 

    },
    
]

export default languages